import { createContext, useContext } from "react";

export interface User {
  id: string;
  username: string;
  avatar: string;
}

interface UserContextProps {
  user: User | null;
  setUser: (user: User | null) => void;
  initialized: boolean;
}

export const UserContext = createContext<UserContextProps | undefined>(
  undefined
);

export function useUser() {
  const context = useContext(UserContext);
  if (!context) throw new Error("useUser must be used within UserProvider");
  return context;
}
